import { render, staticRenderFns } from "./AplicarCoberturas.vue?vue&type=template&id=fc036ff4&scoped=true"
import script from "./AplicarCoberturas.vue?vue&type=script&setup=true&lang=js"
export * from "./AplicarCoberturas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc036ff4",
  null
  
)

export default component.exports